import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getCarRoutes } from "@tenant/cars";

export const useHomePageCarSearch = () => {
  const { t } = useI18nContext();

  const navigate = useNavigate();

  const { FULL_ROUTES } = getCarRoutes();

  const handleMobileRedirect = useCallback(() => {
    navigate(FULL_ROUTES.SEARCH);
  }, [FULL_ROUTES.SEARCH, navigate]);

  return {
    context: {},
    handlers: {
      handleMobileRedirect,
    },
    text: {
      mobileButtonLabel: t("core-cars.search.startSearch"),
    },
  };
};
